import React from "react";

/**
 * GT Royal official logo. The PNG already has its own circular gold-trimmed
 * blue badge — render it cleanly with a subtle drop-shadow, no white plate.
 */
export default function GtLogo({ size = "w-12 h-12", className = "" }) {
  return (
    <img
      src="/gt-logo.png"
      alt="GT Royal"
      className={`${size} ${className} object-contain drop-shadow-md select-none`}
      draggable={false}
    />
  );
}
